import httpServe from './httpServe';
let userService = {};
//登录
userService.userLogin = async function(param) {
    let url = httpServe.getUumpUrl('/pub/registration/login');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//获取comeCode
userService.getCompCode = async function(param) {
    let url = httpServe.getUumpUrl('/pub/registration/getCompCode');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
userService.tencent = async function(param, authorization) {
    let url = 'https://recognition.image.myqcloud.com/ocr/idcard';

    let res = await httpServe.Post(url, param, authorization);

    return res['data'];
};
//发送短信验证码
//type 验证码类型 1-登录,2-找回密码,3-修改手机号 , 4-换绑手机号
userService.sendCode = async function(mobile, type, compCode) {
    let url = httpServe.getUumpUrl('/pub/user/send_mobile_message');
    let res = await httpServe.ajaxPost(url, {
        mobile: mobile,
        type: type,
        compCode: compCode
    }, false);
    return res['data'];
};
/*获取登录方式 */
userService.querySysProp = async function(param) {
    let url = httpServe.getUumpUrl('/pub/registration/querySysProp');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
/*查看实名认证记录 */
userService.getRealNameRecord = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/getRealNameRecord');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
/*注册 */
userService.register = async function(param) {
    let url = httpServe.getUumpUrl('/pub/registration/register');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
userService.changehead = async function(headImgId) {
    let url = httpServe.getUumpUrl('/api/user/updateHead');
    let res = await httpServe.ajaxPost(url, {
        headImgId: headImgId
    });
    return res['data'];
};
//教学计划
userService.queryLessonsplandetail = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/queryLessonsplandetail');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
//预报名登录
userService.loginByPreirdain = async function(param) {
    let url = httpServe.getUumpUrl('/pub/registration/loginByPreirdain');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//是否预报名
userService.checkIsPush = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/checkIsPush');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
//检测是否提交问卷调查
userService.checkIsPushQuestion = async function(param) {
        let url = httpServe.getUumpUrl('/pub/registration/checkIsPushQuestion')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //提交问卷调查（路人）
userService.pushQuestion = async function(param) {
        let url = httpServe.getUumpUrl('/pub/registration/pushQuestion')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //重置预报名
userService.cleanPreordainRecord = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/cleanPreordainRecord');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
//保存预报名
userService.pushPreordainRecord = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/pushPreordainRecord');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
//教学评估的班级
userService.queryEvaluationSheet = async function(param) {
    let url = httpServe.getUumpUrl('api/registration/queryEvaluationSheet');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
//查询收件箱
userService.queryMsgReceiving = async function(param) {
    let url = httpServe.getUumpUrl('/api/msg/query_msg_receiving');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
// 欢迎页
userService.saveOrGetWelcome = async function(param) {
    let url = httpServe.getUumpUrl('/api/company/saveOrGetWelcome');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
userService.downQrCode = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/downQrCode');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];
};
//是否需要实名认证
userService.checkNeedAuth = async function() {
    let url = httpServe.getUumpUrl('/api/registration/checkNeedAuth');
    let res = await httpServe.ajaxPost(url)
    return res['data'];
};
//实名认证
userService.auth = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/auth');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//网络报名查询校区、专业/系、课程、班级入口
userService.select = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/select');
    let res = await httpServe.ajaxP(url, param)
    return res['data'];
};
//检测是否可以报名
userService.checkCanSignUp = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/checkCanSignUp');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//保存报名班级
userService.saveClass = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/saveClass');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//报名简章
userService.getAgreement = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/getAgreement');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//前去缴费
userService.travelToPay = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/travelToPay');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//提交订单

userService.submitOrder = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/submitOrder');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//查询订单
userService.queryOrder = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/queryOrder');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//取消订单
userService.cancelOrder = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/cancelOrder');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//支付订单
userService.payByOrder = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/payByOrder');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//保存学员信息
userService.saveOrUpdateStudent = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/saveOrUpdateStudent');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};
//  根据类型查询字典码
userService.queryCodeInfoByCode = async function(code) {
        let url = httpServe.getUumpUrl('/api/code_info/query_code_info_by_code');
        let param = {
            code: code,
            page: 1,
            pageSize: 999
        }
        let res = await httpServe.ajaxPost(url, param)
        return res['data'];
    }
    //  民族字典码
userService.queryAll = async function(param = {}) {
        let url = httpServe.getTeamUrl('/api/nation/queryAll');
        let res = await httpServe.ajaxPost(url, param)
        return res['data'];
    }
    //校验手机号验证码
userService.checkMobileCode = async function(mobile, mobileCode, type) {
    let url = httpServe.getUumpUrl('/pub/user/check_mobile_code');
    let res = await httpServe.ajaxPost(url, {
        mobile: mobile,
        mobileCode: mobileCode,
        type: type
    }, false);
    return res['data'];
};
//修改密码
userService.changePwd = async function(mobile, newPassword, replyPassword, id, type) {
    let url = httpServe.getUumpUrl('/pub/user/reset_user_password');
    let res = await httpServe.ajaxPost(url, {
        mobile: mobile,
        newPassword: newPassword,
        replyPassword: replyPassword,
        id: id,
        type: type
    });
    return res['data'];
};
//发送短信验证码
//type 验证码类型 1-登录,2-找回密码,3-修改手机号 , 4-换绑手机号
userService.sendCode = async function(mobile, type, compCode) {
    let url = httpServe.getUumpUrl('/pub/user/send_mobile_message');
    let res = await httpServe.ajaxPost(url, {
        mobile: mobile,
        type: type,
        compCode: compCode
    }, false);
    return res['data'];
};
//获取用户信息
userService.loadUser = async function() {
    let url = httpServe.getUumpUrl('/api/user/load_user_info');
    let res = await httpServe.ajaxPost(url, {});
    return res['data'];
};
//创建或者修改请假记录
userService.leaveCreateOrUpdate = async function(param = {}) {
        let url = httpServe.getUumpUrl('/api/registration/createOrUpdateLeave')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //创建或者修改请假记录
userService.leaveQueryLeaveClass = async function(param = {}) {
        let url = httpServe.getUumpUrl('/api/registration/queryLeaveClass')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //查询可请假时间段
userService.leaveQueryTimestamp = async function(param = {}) {
        let url = httpServe.getUumpUrl('/api/registration/queryTimestamp')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //退班
userService.quitClass = async function(param) {
        let url = httpServe.getUumpUrl('/api/registration/quitClass')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //上传文件
userService.uploadFile = async function(file) {
    let url = httpServe.getFileApi('/pub/upload');
    let res = await httpServe.upload(url, [file]);
    return res['data'];
};
// 教学评估项
userService.queryTeachingEvaluationSheetById = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/queryTeachingEvaluationSheetById');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];

};
// 评估
userService.estimate = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/estimate');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];

};
// 图片换取
userService.loadImg = async function(param) {
    let url = httpServe.getUumpUrl('/pub/registration/loadImg');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];

};
//获取系统字典组
userService.querySysCode = async function(company, SysPropSetType) {
        let url = httpServe.getUumpUrl('/pub/code_group/querySysCode');
        let res = await httpServe.ajaxPost(url, {
            "service": company,
            "groupCode": SysPropSetType
        })
        return res['data'];
    }
    // 请假记录
userService.queryLeave = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/queryLeave');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];

};
// 教学评估班级
userService.queryEvaluationSheet = async function(param) {
    let url = httpServe.getUumpUrl('/api/registration/queryEvaluationSheet');
    let res = await httpServe.ajaxPost(url, param);
    return res['data'];

};
//修改邮件状态
userService.updateMsgStatus = async function(msgIds, readFlag) {
    let url = httpServe.getUumpUrl('/api/msg/update_msg_status');
    let res = await httpServe.ajaxPost(url, {
        msgIds: msgIds,
        readFlag: readFlag
    });
    return res['data'];
};
//删除收件箱邮件
userService.deleteMsg = async function(msgReceivingIds) {
    let url = httpServe.getUumpUrl('/api/msg/delete_msg_receiving');
    let res = await httpServe.ajaxPost(url, {
        msgReceivingIds: msgReceivingIds
    });
    return res['data'];
};
//查询未读消息数量
userService.queryMsgCount = async function() {
    let url = httpServe.getUumpUrl('/api/msg/query_msg_receiving_count');
    let res = await httpServe.ajaxPost(url, {});
    return res['data'];
};
//查询发件箱
userService.queryMsg = async function(pageIndex, pageSize, type, search) {
    let url = httpServe.getUumpUrl('/api/msg/query_msg');
    let res = await httpServe.ajaxPost(url, {
        title: search,
        content: search,
        pageIndex: pageIndex,
        pageSize: pageSize,
        type: type,
    });
    return res['data'];
};
//发送邮件
userService.sendMsg = async function(pushTime, title, content, ids, smsFlag, emailFlag, type) {
    let url = httpServe.getUumpUrl('/api/msg/send_msg');
    let res = await httpServe.ajaxPost(url, {
        pushTime: pushTime,
        title: title,
        content: content,
        ids: ids,
        smsFlag: smsFlag,
        emailFlag: emailFlag,
        type: 1,
    });
    return res['data'];
};
//删除发件箱邮件
userService.deleteMsgIn = async function(messageIds) {
    let url = httpServe.getUumpUrl('/api/msg/delete_msg');
    let res = await httpServe.ajaxPost(url, {
        messageIds: messageIds
    });
    return res['data'];
};
userService.getInvite = async function(text) {
    let url = httpServe.getUumpUrl('/pub/user/v_code?codeKey=' + text);
    // let host = window.location.host;
    // if(host.indexOf('localhost') == -1){
    //   url = host + url;
    // }else{
    //   url = url;
    // }
    url = httpServe.serve_host + url;
    return url;
};
//退出
userService.userOut = async function() {
    let url = httpServe.getUumpUrl('/pub/user/logout');
    let token = await window.sessionStorage.getItem('access_token');
    let refresh_token = await window.sessionStorage.getItem('refresh_token');
    let res = await httpServe.ajaxPost(url, {
        access_token: token,
        refresh_token: refresh_token
    }, false);
    return res['data'];
};
//查询问卷调查详情
userService.getDetail = async function(param = {}) {
        let url = httpServe.getUumpUrl('/pub/registration/getDetail')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //查询问卷是否可答
userService.checkQuestionnatire = async function(param = {}) {
        let url = httpServe.getUumpUrl('/pub/registration/checkQuestionnatire')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    // 获取非税支付的html
userService.loadFeiShuiHtml = async function(param = {}) {
    let url = httpServe.getUumpUrl('/api/registration/loadFeiShuiHtml');
    let res = await httpServe.ajaxPost(url, param)
    return res;
}
export default userService;


// WEBPACK FOOTER //
// ./src/utils/user.js